import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ConnectedRoomHeader } from './FragmentHeader/RoomHeader';
import { Fragment } from './Fragment';
import { FragmentBody } from './FragmentBody';
import { NextButtonWithValidation } from './NextButton';
import { SlideType } from '../../../models';
import { SlideGroupContext } from '../../../components/SlideManager';
import { ConnectedRoomSelectorContent } from '../../RoomSelector/RoomSelectorContent';
import {
    hasKidsErrors,
    hasNonPrimeHotelKidsErrors,
    isHotelProductActive,
    isPrime
} from '../../../redux/currentSearch/selectors';
import { FieldHeaderPrisma } from './FragmentHeader';
import { ABUtils } from '../../../utils';

export const RoomSelectorFragment = ({ hasKidsErrors, isHotel, hasNonPrimeHotelKidsErrors, isPrime }) => {
    const { isOpenedWithEmptyFields, getCurrent } = React.useContext(SlideGroupContext);
    const { isCssVariationMobile } = ABUtils.getABs();
    const currentSlideGroup = getCurrent();
    const isDone = currentSlideGroup.history.indexOf(SlideType.ROOM) > -1 || !isOpenedWithEmptyFields;
    const isNonPrimeHotel = isHotel && !isPrime;

    return (
        <Fragment
            id={SlideType.ROOM}
            isDone={isDone}
            isEmpty={false}
            setValue={() => {
            }}
        >
            {() => (
                <React.Fragment>
                    {!isCssVariationMobile && (
                        <ConnectedRoomHeader />
                    )}
                    {isCssVariationMobile && (
                        <FieldHeaderPrisma
                            textKey="flightsManager.selection.pax.title"
                        />
                    )}
                    <FragmentBody padding={false}>
                        <ConnectedRoomSelectorContent
                            isNative
                            hasError={isNonPrimeHotel ? hasNonPrimeHotelKidsErrors : hasKidsErrors}
                        />
                    </FragmentBody>
                    <NextButtonWithValidation type={SlideType.ROOM} testId="room-selector-next-btn" />
                </React.Fragment>
            )}
        </Fragment>
    );
};

RoomSelectorFragment.propTypes = {
    hasKidsErrors: PropTypes.bool.isRequired,
    hasNonPrimeHotelKidsErrors: PropTypes.bool.isRequired,
    isHotel: PropTypes.bool.isRequired,
    isPrime: PropTypes.bool.isRequired,
};

const mapStateToPropsSelector = createStructuredSelector({
    hasKidsErrors: hasKidsErrors,
    isHotel: isHotelProductActive,
    hasNonPrimeHotelKidsErrors: hasNonPrimeHotelKidsErrors,
    isPrime: isPrime,
});

export const ConnectedRoomSelectorFragment = connect(mapStateToPropsSelector, {})(RoomSelectorFragment);
